
import { Html } from "@react-three/drei";
import { Compass } from "lucide-react";

interface RotationControlProps {
  size: number;
  autoRotate: boolean;
  onToggleRotation: () => void;
}

const RotationControl = ({ size, autoRotate, onToggleRotation }: RotationControlProps) => {
  return (
    <Html position={[size, -size, 0]}>
      <button
        className="bg-black/60 hover:bg-black/80 border border-blue-500/50 text-blue-400 px-4 py-2 rounded text-sm shadow-lg pointer-events-auto transition-all flex items-center gap-2"
        onClick={onToggleRotation}
      >
        <Compass className="h-4 w-4" />
        {autoRotate ? "Zaustavi rotaciju" : "Pokreni rotaciju"}
      </button>
    </Html>
  );
};

export default RotationControl;
